import createIcon from '../../createIcon';

/**
 * @component @name GppBad
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkw0IDVWMTEuMDlDNCAxNi4xNCA3LjQxIDIwLjg1IDEyIDIyQzE2LjU5IDIwLjg1IDIwIDE2LjE0IDIwIDExLjA5VjVMMTIgMlpNMTUuNSAxNC4wOUwxNC4wOSAxNS41TDEyIDEzLjQyTDkuOTEgMTUuNUw4LjUgMTQuMDlMMTAuNTkgMTJMOC41IDkuOTFMOS45MSA4LjVMMTIgMTAuNTlMMTQuMDkgOC41TDE1LjUgOS45MUwxMy40MiAxMkwxNS41IDE0LjA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GppBad = createIcon('GppBad', [
  [
    'path',
    {
      d: 'M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM15.5 14.09L14.09 15.5L12 13.42L9.91 15.5L8.5 14.09L10.59 12L8.5 9.91L9.91 8.5L12 10.59L14.09 8.5L15.5 9.91L13.42 12L15.5 14.09Z',
      key: '19q00v',
    },
  ],
]);

export default GppBad;
